import { Form, Formik } from "formik";
import FormField from "../forms/FormField";
import * as Yup from "yup";
import { useEffect, useMemo, useRef, useState } from "react";
import { useGetLoyaltyProgram } from "../../hooks/Query/useGetAllLoyaltyProgram";
import { useGetForfeitureReport } from "../../hooks/Query/useGetForfeitureReport";
import { toast } from "react-toastify";
import { TailwindSpinner } from "../Spinner/Spinner";
import { DownloadModal } from "../DownloadModal";
import MemberEnrollmentTable from "../MemberEnrolements/MemberEnrolmentTable";
import { CampaignReportColumn, ExpiryReportColumn } from "../Table/TableColums";
import { downloadFile } from "../../utils/downloadFile";

const validationSchema = Yup.object({
  fromDate: Yup.date().required("From date is required"),
  tillDate: Yup.date().required("Till date is required"),
  country: Yup.string().required("Country is required"),
  programs: Yup.string().required("Programs is required"),
  limit: Yup.string(),
});
const initialValues = {
  fromDate: "",
  tillDate: "",
  country: "",
  programs: "",
  limit: "",
};
export default function CreatePointForfeitureReport() {
  const [page, setPage] = useState(1);
  const [payloadData, setPayloadData] = useState();
   const [downloadPayload, setDownloadPayload]=useState()
  const [loyaltyPrograms, setLoyaltyPrograms] = useState();
  const [showDownloadOption, setShowDownloadOption] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState("");
  const [formData, setFormData] = useState(initialValues);
  const [openModal, setOpenModal] = useState(false);
  const [shouldDownload, setShouldDownload] = useState(false);
  const [forfeitureReport, setForfeitureReport] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const formikRef = useRef();

  // GET REPORT
  const {
    data: report,
    isFetching: loading,
    refetch,
  } = useGetForfeitureReport({
    payload: payloadData,
    page: page,
  });
     // DOWNLOAD REPORT (Not available yet)
      // const { data: downloadData, isLoading } = useDownloadRedemptionReport({
      //   payload: downloadPayload
      // });

 //UNCOMMENT WHEN WE HAVE DOWNLOAD ENDPOINT
          // useEffect(() => {
          //   if (shouldDownload && downloadData?.data?.data?.length > 0) {
          //     downloadFile({
          //       data: downloadData?.data?.data,
          //       format: downloadFormat,
          //       fileName: "redemption_report",
          //     });
        
          //     setShouldDownload(false);
          //   } else if (
          //     shouldDownload &&
          //     !isLoading &&
          //     !downloadData?.data?.data?.length
          //   ) {
          //     toast.warning("No data available to download.");
          //     setShouldDownload(false);
          //   }
          // }, [downloadData, shouldDownload, downloadFormat, isLoading, downloadPayload]);

  // Sync formData with Formik values
  useEffect(() => {
    const interval = setInterval(() => {
      if (formikRef.current?.values) {
        setFormData(formikRef.current.values);
      }
    }, 300);
    return () => clearInterval(interval);
  }, []);

  // Show download modal if limit is "All"
  useEffect(() => {
    if (formData?.limit === "All") {
      setOpenModal(true);
      setShowDownloadOption(false);
    }
  }, [formData]);

  const payload = useMemo(
    () =>
      `from_date=${formData?.fromDate}&to_date=${formData?.tillDate}&report_type=${formData?.report}`,
    [formData]
  );

  // GET LOYALTY PROGRAM
  const { data: loyaltyProgram, isFetching: isLoadingProgram } =
    useGetLoyaltyProgram();

  useEffect(() => {
    if (!isLoadingProgram && loyaltyProgram?.data) {
      setLoyaltyPrograms(loyaltyProgram?.data?.data);
    }
  }, [loyaltyProgram, isLoadingProgram]);

  const countries = [
    {
      value: 1,
      label: "Nigeria",
    },
  ];
  useEffect(() => {
    if (!loading && report?.data) {
      setForfeitureReport(report?.data);
    }
  }, [loading, report]);

  const handleShowDownloadReport = (values) => {
    if (
      values?.fromDate === "" ||
      values?.tillDate === "" ||
      values?.programs === "" ||
      values?.country === ""
    ) {
      return toast.error("Kindly fill all required filleds.");
    } else {
      setShowDownloadOption(!showDownloadOption);
    }
  };



  const handleDownloadReport = (values, format) => {
    if (
      values?.fromDate === "" ||
      values?.tillDate === "" ||
      values?.programs === "" ||
      values?.country === "" ||
      values?.limit === ""
    ) {
      toast.error("Select your download limit");
      return;
    }
    setDownloadPayload(values);
    setDownloadFormat(format);
    setShouldDownload(true);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    refetch();
  };
  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6 bg-white rounded-lg">
      <div className="mb-6">
        <h1 className="text-lg font-medium text-gray-900">Points Forfeiture</h1>
        <p className="text-grey-200 text-sm">
          View all point forfeiture report in the program
        </p>
      </div>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        // onSubmit={(values) => handleSubmit(values)}

        onSubmit={(values) => {
          setPayloadData(values);
        }}
      >
        {({ values, errors }) => {
          return (
            <Form className="md:w-[711px] relative h-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                <FormField
                  label="From Date"
                  name="fromDate"
                  type="date"
                  required={true}
                />
                <FormField
                  label="Till Date"
                  name="tillDate"
                  type="date"
                  required={true}
                />
                <FormField
                  label="Loyalty Program"
                  name="programs"
                  type="select"
                  options={loyaltyPrograms?.map((loy) => ({
                    value: loy?.Loyalty_program_id,
                    label: loy?.Loyalty_program_name,
                  }))}
                  required={true}
                />

                <FormField
                  label="Select Country"
                  name="country"
                  type="select"
                  options={countries}
                  required={true}
                />

                {showDownloadOption && (
                  <FormField
                    label="Download Limit"
                    name="limit"
                    type="select"
                    options={[
                      { value: "100000", label: "100,000" },
                      { value: "200000", label: "200,000" },
                      { value: "500000", label: "500,000" },
                        { value: "1000000", label: "1,000,000" },
                      { value: "All", label: "All" },
                    ]}
                  />
                )}
              </div>

              <div className="flex flex-col md:flex-row gap-4 mt-6 justify-between items-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-mysecondary hover:bg-blue-800 text-white px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm"
                >
                  {loading ? <TailwindSpinner /> : "Search"}
                </button>
                <div>
                  <button
                    type="button"
                    // disabled={isPending}
                    variant="outline"
                    className=" text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm "
                    onClick={() => handleShowDownloadReport(values)}
                  >
                    {/* <Download className="mr-2 h-4 w-4" /> */}
                    {" Download As"}
                  </button>
                </div>
              </div>
              {showDownloadOption && (
                <div className="flex justify-center  md:justify-end ">
                  <div className="  right-0 mt-2 text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 rounded flex items-center  justify-end w-[189px]  flex-col">
                    <button
                      type="button"
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white"
                      onClick={() => handleDownloadReport(values, "pdf")}
                    >
                      Pdf
                    </button>
                    <button
                      type="button"
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white"
                      onClick={() => handleDownloadReport(values, "csv")}
                    >
                      Csv
                    </button>
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>

      {forfeitureReport?.length > 0 ? (
        <MemberEnrollmentTable
          columns={ExpiryReportColumn}
          data={forfeitureReport}
          page={page}
          setPage={setPage}
          handlePageChange={handlePageChange}
          totalPage={totalPage}
          loading={loading}
          title={"Point Forfeiture"}
        />
      ) : 
      report && report?.data?.length === 0 ? (
          
          <div className="text-center text-gray-500 mt-10">
            No data available for the selected criteria.
          </div>
        )
      :null}
      {openModal && (
        <DownloadModal
          setOpenModal={setOpenModal}
          value={formData}
          openModal={openModal}
          payload={payload}
        />
      )}
    </div>
  );
}
